import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BackIcon, CloseIcon, CloseNotBorderIcon } from "Components/icons/Icons";
import { cn } from "utils/commonUtils";

const BackButton = ({ className = "", onClick, text = "Back", title = "" }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = () => {
        // Gọi hàm onClick nếu được truyền từ props
        if (typeof onClick === "function") {
            onClick();
        } else {
            // Thực hiện điều hướng mặc định
            const previousPage = location?.state?.from;
            navigate(previousPage);
        }
    };

    return (
        <div
            onClick={handleClick}
            className={cn(`
                tw-relative
                tw-flex tw-mb-10 tw-w-full sm:tw-max-w-[120px]
                sm:tw-bg-[linear-gradient(263.11deg,#549a9c_5.13%,#65acae_86.84%)]
                sw:tw-shadow-[17px_13px_18px_rgba(0,126,197,0.14)]
                sm:tw-rounded-[30px]
                tw-text-white
                tw-font-normal sm:tw-font-semibold
                tw-text-[18px] tw-leading-[21px]
                tw-py-[18px] tw-px-[18px]
                tw-border-0
                tw-cursor-pointer   
                `, className)}
        >
            {/* &#x2190; {text} */}
            <span className="tw-show-desktop tw-mr-2">
                &#x2190;
            </span>
            {/* <CloseNotBorderIcon className="tw-show-mobile" />
            <CloseIcon/> */}
            <BackIcon className="tw-show-mobile" />
            <span className="tw-show-desktop">{text}</span>
            <span className="
                    tw-show-mobile
                    tw-m-auto
                    tw-font-[450]
                    tw-text-[18px]
                    tw-leading-[140%]
                    tw-text-[#2C323A]"
            >{title}</span>
        </div>
    );
};

export default BackButton;
